import React from "react";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import { Button } from "antd";

export const MatchingTargetsDrawerToggleButton = React.memo<{ isOpen: boolean; onToggle: () => void; }>(
  ({ isOpen, onToggle }) =>
    <Button onClick={onToggle} type="text" icon={isOpen ? <DownOutlined /> : <UpOutlined />} />
);
